module.exports = __webpack_public_path__ + "static/media/miaou4.e70a676a.mp3";